<template>
  <div class="Container">
    <h2 class="ViewHeading">C-1 Calibration</h2>
    <b-card>
      <b-table
        sticky-header
        id="C1Table"
        :items="c1items"
        :fields="fields"
        no-border-collapse
        hover
        show-empty
        empty-text="You currently dont have any Assets of this type"
        responsive
        small
      >
        <template v-slot:cell(Calibrate)="{ item }">
          <b-button
            variant="outline-info"
            size="sm"
            v-on:click="showCALWizard(item.ID,'C1')"
          >
            Calibrate
          </b-button>
        </template>
        <template v-slot:cell(ID)="{ item }">
          {{ getNewName(item.ID, "C1") }}
        </template>
      </b-table>
      <hr />
    </b-card>
     <b-modal
            size="xl"
            header-bg-variant="light"
            header-text-variant="dark"
            ref="CalWizard"
            id="CalWizard"
            title="Device Calibrations"
            hide-footer>
            <b-card>
            <CALWizard @WizardComplete="FinishCALWizard" :Type="Type" :ID="ID"/>
            </b-card>

        </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { IDToHuman } from "../../CustomFunctions/HumanName.js";
import CALWizard from "../CalibrationWizard/CALWizard.vue";

export default {
  props:['DataPass','Type','ID'],
  computed: {},
  components: {CALWizard},

  data() {
    return {
      VW: Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      ),
      dataToDisplay: [],
      UserURN: localStorage.getItem("UserURN"),
      UserProfile: localStorage.getItem("ProfilePortal"),
      clCompany: localStorage.getItem("Company"),
      nickname: localStorage.getItem("Nickname"),
      fields: [
        { key: "ID", variant: "primary" },
        { key: "Type" },
        { key: "DeptFloor" },
        { key: "PositionNote" },
        { key: "Status" },
        { key: "LocationGroups" },
        { key: "Calibrate" },
      ],
      c1items: [],
      selectedlocation: localStorage.getItem("location"),
      DeviceIDToChange: { C1: [], O1: [] },
      IDsIhaveChanged: { C1: [], O1: [] },
      IDsToChange: { C1: [], O1: [] },
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ClarenceDeviceLocation",
      LocationDict: [
        {
          Location: this.selectedlocation,
          FilterType: "",
          Feed: "",
          State: "",
        },
      ],
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        let fulldataarray = response.data.Values

         for (let x=0;x<fulldataarray.length;x++){
          if(fulldataarray[x][6] == 'C-1'){
            this.IDGetArrays(fulldataarray[x][0], fulldataarray[x][6]);

            this.c1items.push({
              ID: fulldataarray[x][0],
              Type: fulldataarray[x][6],
              DeptFloor: fulldataarray[x][1],
              Position: "",
              PositionNote: fulldataarray[x][2],
              LocationGroups: fulldataarray[x][3],
              grouplist: fulldataarray[x][5],
              Status: fulldataarray[x][4],
            });
          } 
        }

        this.SwitchToHuman("C1");

      });
  },

  created() {
    window.addEventListener("resize", this.ViewWidth);
  },
  destroyed() {
    window.removeEventListener("resize", this.ViewWidth);
  },

  methods: {
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        let Names = await IDToHuman(this.IDsToChange.O1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        let Names = await IDToHuman(this.IDsToChange.C1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data, Type) {
      let ClarenceType = Type;

      if (ClarenceType == "O1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (data == this.DeviceIDToChange.O1[i].ID) {
            return this.DeviceIDToChange.O1[i].Name;
          }
        }
      } else {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (data == this.DeviceIDToChange.C1[i].ID) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }
      return data;
    },

    async IDGetArrays(ID, Type) {
      Type = Type.replace("-", "");
      if (Type == "C1") {
        if (ID.length > 9) {
          ID = ID.slice(0, 9);
        }

        if (
          this.IDsIhaveChanged.C1.includes(ID) ||
          this.IDsToChange.C1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.C1.includes(ID) == false &&
          this.IDsToChange.C1.includes(ID) == false
        ) {
          this.IDsToChange.C1.push(ID);
        }
      }
      if (Type == "O1") {
        if (
          this.IDsIhaveChanged.O1.includes(ID) ||
          this.IDsToChange.O1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.O1.includes(ID) == false &&
          this.IDsToChange.O1.includes(ID) == false
        ) {
          this.IDsToChange.O1.push(ID);
        }
      }
    },

    ViewWidth(e) {
      this.VW = e.currentTarget.innerWidth;
    },


    addZero(i) {
      if (i < 10) {i = "0" + i}
      return i;
      },

     showCALWizard(id,devicetype){
          this.ID = id,
          this.Type = devicetype,
          this.$refs["CalWizard"].show();
        },
        FinishCALWizard(){
            alert("Device Calibration completed")
            this.$refs["CalWizard"].hide();
        },
  },
  watch: {},
};
</script>

<style scoped>
</style>
